var exports = {
  "V": "Description__ae_SLr",
  "M": "MessageList__Eg5ZgZ",
};

module.exports = exports;
